<template>
  <el-drawer
    ref="drawerRef"
    :title="title"
    size="55%"
    :with-header="true"
    :visible="drawer"
    v-bind="$attrs"
    :before-close="handleClosed"
    @closed="handleClosed"
  >
    <el-container direction="vertical">
      <el-main>
        <el-row :gutter="20">
          <!-- <el-col :span="13" :sm="24" :md="13" :xs="24"> -->
          <el-col :span="24">
            <el-form
              ref="el_form"
              :model="model"
              label-position="left"
              size="mini"
              label-width="120px"
            >
              <el-row type="flex column">
                <el-col>
                  <template v-if="isView">
                    <!-- <el-badge
                    :value="model.Phase.Name"
                    class="item"
                    type="primary"
                  >
                    <h2>{{ model.Name }}</h2>
                  </el-badge> -->

                    <el-tooltip
                      v-if="model.Phase"
                      effect="dark"
                      content="Fase"
                      placement="top-start"
                      :disabled="!model.Phase.Name"
                    >
                      <el-tag type="success" v-if="model.Phase.Name">{{
                        model.Phase.Name
                      }}</el-tag>
                    </el-tooltip>
                  </template>
                  <template>
                    <div style="display: flex; flex-direction: row">
                      <el-col>
                        <el-form-item
                          label="Descripción de Negociacion"
                          prop="Name"
                          :rules="[
                            {
                              required: true,
                              message: 'La descripción es requerida'
                            }
                          ]"
                        >
                          <el-input
                            :style="{ width: '350px' }"
                            type="textarea"
                            v-model="model.Name"
                            :disabled="isView"
                            autofocus
                          ></el-input>
                        </el-form-item>
                      </el-col>

                      <div>
                        <el-col>
                          <el-form-item
                            label="Producto"
                            prop="ProductID"
                            v-if="drawer"
                            :rules="[
                              { required: true, message: 'Producto requerido' }
                            ]"
                          >
                            <product-selector
                              :product="model.ProductID"
                              :disabled="controlerViewEdit"
                              @change="model.ProductID = $event"
                            />
                          </el-form-item>
                        </el-col>

                        <el-col>
                          <el-form-item
                            label="Servicio"
                            prop="DealsTypeID"
                            :rules="[
                              {
                                required: true,
                                message: 'Servicio es requerido'
                              }
                            ]"
                          >
                            <el-select
                              v-model="model.DealsTypeID"
                              v-loading="loading"
                              clearable
                              placeholder="Tipo de servicio"
                              :disabled="controlerViewEdit"
                            >
                              <el-option
                                v-for="item in list_deal_of_types"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                :disabled="!item.IsEnabled"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </div>
                    </div>
                  </template>
                </el-col>
              </el-row>

              <div class="deal-footer">
                <div class="flex">
                  <table class="box" contenteditable="false">
                    <tbody>
                      <div style="display: flex; gap: 20px">
                        <tr>
                          <div></div>
                          <td id="total_unit">
                            <el-form-item
                              prop="UnitPrice"
                              size="mini"
                              label="Prec. unitario"
                              :rules="[{ required: true }]"
                            >
                              <el-input-number
                                v-model="model.UnitPrice"
                                :min="0"
                                :disabled="controlerViewEdit"
                              ></el-input-number>
                            </el-form-item>
                          </td>
                        </tr>
                        <tr>
                          <td id="total_qty">
                            <el-form-item
                              label="Cantidad"
                              prop="Quantity"
                              size="mini"
                              :rules="[{ required: true }]"
                            >
                              <el-input-number
                                v-model="model.Quantity"
                                :min="0"
                                :disabled="controlerViewEdit"
                              ></el-input-number>
                            </el-form-item>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label for=""><strong>Total:</strong></label>
                            <span id="total_price" style="float: right">{{
                              model.Amount
                            }}</span>
                          </td>
                        </tr>
                      </div>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- <div style="width: 300px; height: 10px;">
                <el-progress
                  :percentage="
                    model.Phase !== undefined ? model.Phase.Percentaje : 0
                  "
                ></el-progress>
              </div> -->

              <el-row :gutter="20" class="mt-20" type="flex column">
                <el-col :span="8" :xs="24" :sm="24" :md="24" :lg="12">
                  <!-- selector de prospecto -->
                  <el-form-item
                    label="Prospecto"
                    prop="Name"
                    v-if="
                      (showProspect || (showProspect && isView)) &&
                      isEdit == true
                    "
                    :rules="[
                      { required: true, message: 'El prospecto es requerido' }
                    ]"
                  >
                    <el-col :span="12" style="padding: 0">
                      <el-select
                        v-model="Name"
                        clearable
                        filterable
                        reserve-keyword
                        remote
                        placeholder="Seleccionar o buscar Prospecto"
                        :disabled="true"
                        :remote-method="remoteMethodProspect"
                        style="
                          border-bottom-right-radius: 0;
                          border-top-right-radius: 0;
                        "
                      >
                        <el-option :label="Name" :value="code"> </el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>

                  <el-form-item
                    label="Prospecto"
                    prop="ContactCode"
                    v-if="
                      (showProspect || (showProspect && isView)) &&
                      isEdit == false
                    "
                    :rules="[
                      { required: true, message: 'El prospecto es requerido' }
                    ]"
                  >
                    <el-col :span="12" style="padding: 0">
                      <el-select
                        v-model="model.ContactCode"
                        v-loading="loadingProspect"
                        clearable
                        filterable
                        reserve-keyword
                        remote
                        placeholder="Seleccionar o buscar Prospecto"
                        :disabled="isView"
                        @change="handleChangeProspect"
                        @keyup.enter="handleChangeProspect"
                        style="
                          border-bottom-right-radius: 0;
                          border-top-right-radius: 0;
                        "
                      >
                        <el-option
                          v-for="(item, index) in listProspects"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-col>

                    <el-col :span="2" style="padding: 0">
                      <el-button
                        type="info"
                        icon="el-icon-view"
                        style="
                          border-bottom-left-radius: 0;
                          border-top-left-radius: 0;
                        "
                        @click="handleClickViewProspect"
                      />
                    </el-col>
                  </el-form-item>

                  <!-- Selector de cliente -->
                  <el-form-item
                    label="Cliente"
                    prop="CustomerCode"
                    v-if="showClient || (showClient && isView)"
                    :rules="[
                      { required: true, message: 'El cliente es requerido' }
                    ]"
                  >
                    <el-col :span="12" style="padding: 0">
                      <el-select
                        v-model="model.CustomerCode"
                        v-loading="loading_customers"
                        clearable
                        filterable
                        reserve-keyword
                        placeholder="Seleccionar o buscar cliente"
                        :disabled="isView"
                        @change="handleChangeCustomer"
                        style="
                          border-bottom-right-radius: 0;
                          border-top-right-radius: 0;
                        "
                      >
                        <el-option
                          v-for="(item, index) in list_customers"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="2" style="padding: 0">
                      <el-button
                        type="info"
                        icon="el-icon-view"
                        style="
                          border-bottom-left-radius: 0;
                          border-top-left-radius: 0;
                        "
                        @click="handleClickViewClient"
                      />
                    </el-col>
                  </el-form-item>

                  <!-- Contacto del prospecto o del cliente -->
                  <el-form-item
                    label="Contacto"
                    prop="ContactDocument"
                    :rules="[
                      { required: true, message: 'El contacto es requerido' }
                    ]"
                  >
                    <el-select
                      v-model="model.ContactDocument"
                      v-loading="loadingContact"
                      clearable
                      filterable
                      reserve-keyword
                      placeholder="Seleccionar o buscar el contacto"
                      :disabled="controlerViewEdit"
                    >
                      <el-option
                        v-for="(item, index) in listContact"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    label="Contrato"
                    prop="ContractTimeID"
                    :rules="[{ required: true, message: 'Contrato requerido' }]"
                  >
                    <el-select
                      v-model="model.ContractTimeID"
                      v-loading="loading"
                      clearable
                      placeholder="Seleccionar contrato"
                      filterable
                      :disabled="controlerViewEdit"
                    >
                      <el-option
                        v-for="item in list_times"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="!item.IsEnabled"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    label="Vendedor"
                    prop="SellerId"
                    :rules="[{ required: true, message: 'Vendedor requerido' }]"
                  >
                    <SellerSelector
                      v-model="model.SellerId"
                      :disabled="controlerViewEdit"
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="8" :xs="24" :sm="24" :md="24" :lg="12">
                  <el-form-item
                    label="Serv. cliente"
                    prop="CustomerServiceId"
                    v-if="drawer"
                    :rules="[
                      {
                        required: true,
                        message: 'Servicio al cliente requerido'
                      }
                    ]"
                  >
                    <CustomerServiceSelector
                      v-model="model.CustomerServiceId"
                      :disabled="controlerViewEdit"
                    />
                  </el-form-item>

                  <el-form-item
                    label="Sop. ventas"
                    prop="SupportSellerId"
                    v-if="isView || isEdit"
                    :rules="[
                      { required: false, message: 'Soporte de venta requerido' }
                    ]"
                  >
                    <SupportSellerSelector
                      v-model="model.SupportSellerId"
                      :disabled="controlerViewEdit"
                      :byUser="false"
                    />
                  </el-form-item>

                  <el-form-item
                    label="Modena"
                    prop="CurrencyID"
                    :rules="[
                      { required: true, message: 'La moneda es requerida' }
                    ]"
                  >
                    <el-select
                      v-model="model.CurrencyID"
                      clearable
                      placeholder="Moneda"
                      v-loading="loading"
                      :disabled="controlerViewEdit"
                    >
                      <el-option
                        v-for="item in list_currency"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="!item.IsEnabled"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    label="Fecha de cierre"
                    prop="FinalDate"
                    :rules="[
                      {
                        required: true,
                        message: 'La fecha de cierre es requerida'
                      }
                    ]"
                  >
                    <el-date-picker
                      v-model="model.FinalDate"
                      type="date"
                      placeholder="Fecha de cierre"
                      format="yyyy/MM/dd"
                      :disabled="controlerViewEdit"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col
                  v-if="model.PhaseID === 8"
                  :span="8"
                  :xs="24"
                  :sm="24"
                  :md="24"
                  :lg="12"
                >
                  <el-form-item label="Razón de Perdida" prop="Reason">
                    <el-input
                      type="textarea"
                      v-model="model.Reason"
                      :autosize="true"
                      :disabled="true"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <hr class="secondary-text" />

              <el-row :gutter="20">
                <el-col :span="24"
                  ><div class="grid-content bg-purple"></div>
                  <el-form-item style="float: right" label="" label-width="0">
                    <el-button
                      v-if="!isView"
                      :loading="loadingButton"
                      type="primary"
                      @click="onSubmit"
                    >
                      {{ buttonTitle }}
                    </el-button>
                    <el-button @click="handleClosed">Cancel</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>

          <!-- <el-col :span="10" :offset="1" :sm="23" :md="10" :xs="23">
            <el-tabs v-model="activeName">
              <el-tab-pane name="comments">
                <span slot="label"
                ><i class="el-icon-chat-dot-round"></i> Comantarios</span
              >
                <comment-list />
              </el-tab-pane>
            </el-tabs>
          </el-col> -->
        </el-row>
      </el-main>
    </el-container>
    <ProspectDetails
      ref="detailsProspect"
      :ProspectData="dataProspect"
      :append-to-body="true"
      :drawer.sync="prospectDrawer"
      @closeDrawer="handleProspectDetailDrawerClose"
    ></ProspectDetails>

    <CustomerDetail ref="detailsCustomer" :append-to-body="true" />
  </el-drawer>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Deal from "@/models/deals/Deal";
import ProspectDetails from "@/components/prospects/ProspectDetails.vue";
import CustomerDetail from "@/components/customers/CustomerDetail.vue";
import ProductSelector from "@/components/Company/ProductSelector.vue";
import SellerSelector from "@/components/Company/SellerSelector.vue";
import CustomerServiceSelector from "@/components/Company/CustomerServiceSelectorbyEmployeeId.vue";
import SupportSellerSelector from "@/components/Company/SupportSellerSelector.vue";

export default {
  name: "DealsFormDrawer",
  components: {
    ProspectDetails,
    CustomerDetail,
    ProductSelector,
    SellerSelector,
    CustomerServiceSelector,
    SupportSellerSelector
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Nueva Negociacion"
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    },
    commants: {
      type: Array,
      default: () => []
    },
    initModel: {
      type: Object,
      required: false,
      default: () => {}
    },
    isProspect: {
      type: Boolean,
      default: false
    },
    isClient: {
      type: Boolean,
      default: false
    },
    fromAction: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: null,
      required: false
    },
    Name: {
      type: String,
      default: null,
      required: false
    }
  },
  async created() {
    await this.fetchCustomers();

    this.$store.commit("prospects/SET_DEFAULT_HTTP_PARAMS", {
      params: {
        userName: this.currentUser.UserName,
        companyId: this.currentCompany,
        salesPersonCode: this.currentUser.PersonCode,
        SalesPersonName: this.currentUser.SalesPersonName,
        Page: 1,
        Limit: 9999
      }
    });
    this.loadingProspect = true;
    this.searchProspect({ search: "" }).then(
      () => (this.loadingProspect = false)
    );
  },
  data() {
    return {
      loading: false,
      loadingButton: false,
      loadingProspect: false,
      loadingContact: false,
      activeName: "comments",
      // True si el cliente viene seleccionado desde la accion de cliente.
      disableCustomerName: false,
      modelCache: Deal,
      model: Deal,
      rules: {
        Name: [{ required: true }],
        ContactDocument: [{ required: true, trigger: "change" }]
      },
      dataProspect: {},
      dataCustomer: {},
      prospectDrawer: false
    };
  },
  methods: {
    // ...mapActions({
    //   getByCustomerCode: "contact/getByCustomerCode",
    //   getByProspectCode: "contact/getByProspectCode"
    // }),
    ...mapGetters({
      getCurrency: "currency/getById",
      getCustomerByName: "customers/getCustomerByName"
    }),
    ...mapActions({
      createDeal: "deals/create",
      fetchCustomers: "customers/getCustomers",
      searchProspect: "prospects/searchProspects",
      getByProspectCode: "contact/getByProspectCode",
      getByCustomerCode: "contact/getByCustomerCode"
    }),
    handleClosed() {
      // clear form
      this.model = Deal;
      this.$emit("close-drawer");
      this.$nextTick(function () {
        this.$refs.el_form.clearValidate();
        this.$refs.el_form.resetFields();
        this.model.ProductID = "";
        //console.log("resetFields",this.$refs.el_form.resetFields)
      });
    },
    handleChangeProspect(val) {
      if (val !== "") {
        this.loadingContact = true;
        this.getByProspectCode({
          contactCode: val
        }).then(() => {
          this.loadingContact = false;
        });
      } else {
        this.$store.commit("contact/list", []);
      }
    },
    handleChangeCustomer(val) {
      if (val !== "") {
        this.loadingContact = true;

        this.getByCustomerCode({ customerCode: val }).then(
          () => (this.loadingContact = false)
        );
      } else {
        this.$store.commit("contact/list", []);
      }
    },
    onSubmit() {
      this.$refs.el_form.validate((valid) => {
        if (valid) {
          if (!this.model.Amount) {
            this.$message.error("El monto es requerido");
            return false;
          }

          try {
            this.model.ContactName = this.listContact.find(
              (c) => c.Code === this.model.ContactDocument
            ).FullName;
          } catch (error) {
            if (error.name === "TypeError") {
              this.$message.error("Contacto no selecionado");
            } else {
              this.$message.error("Error no controlado");
            }
            return false;
          }

          const user_id = this.currentUser.UserID;

          this.model.CompanyID = this.currentCompany;
          this.model.UpdatedBy = user_id;

          if (this.isEdit === false) {
            this.model.ResponsibleID = user_id;
            this.model.CreatedBy = user_id;
            this.model.PhaseID = 1;
            this.model.ContactCode = this.code;

            this.loadingButton = true;
            this.$http
              .post("/api/deals/add", this.model)
              .then((resp) => {
                this.handleClosed();
                this.$emit("deal-created", "success", resp);
                this.$message.success("Negociacion creada");
                this.loadingButton = false;
              })
              .catch((error) => {
                this.$message.error(error);
                this.$emit("deal-created", "error", error);
                this.loadingButton = false;
              });

            // this.createDeal(this.model)
            //   .then(resp => {
            //     this.$store.commit("deals/UNSHIFT_DEAL_BY_PHASE", {
            //       phaseId: 1,
            //       deal: resp.data
            //     });
            //     this.$refs.drawerRef.closeDrawer();
            //     this.$emit("deal-created", "success", resp);
            //     this.$message.success("Oportunidad creada");
            //   })
            //   .catch(error => {
            //     this.$message.error(error);
            //     this.$emit("deal-created", "error", error);
            //   });
          } else {
            // actualizar
            this.$http
              .post("/api/deals/update", this.model)
              .then((response) => {
                this.$emit("refresh-table");
                this.$store.commit("deals/UPDATE_DEAL", response.data);
                this.handleClosed();
                this.$message.success("Negociacion actulizada");
                this.loadingButton = false;
              });
          }
          this.$emit("close-drawer");
        } else {
          return false;
        }
      });
    },
    remoteMethodProspect(query) {
      if (query !== "") {
        this.loadingProspect = true;
        setTimeout(() => {
          this.$store.commit("prospects/SET_DEFAULT_HTTP_PARAMS", {
            params: {
              userName: this.currentUser.UserName,
              companyId: this.currentCompany,
              salesPersonCode: this.currentUser.PersonCode,
              SalesPersonName: this.currentUser.SalesPersonName,
              Page: 1,
              Limit: 9999
            }
          });
          this.searchProspect({ search: query }).then(
            () => (this.loadingProspect = false)
          );
        }, 200);
      }
    },
    async handleClickViewProspect() {
      const resp = await this.$http.get(
        `/api/prospects/${this.code}/${this.currentCompany}`
      );
      const { data } = resp;
      this.dataProspect = data;
      this.prospectDrawer = true;
    },
    async ClickEditProspect() {
      const resp = await this.$http.get(
        `/api/prospects/${this.code}/${this.currentCompany}`
      );
      const { data } = resp;
      this.dataProspect = data;
      this.prospectDrawer = false;
      this.model.CompanyNameProspect = this.dataProspect.CompanyName;
    },
    async handleClickViewClient() {
      const resp = await this.$http.get(`/api/customers/${this.code}`);
      const { data } = resp;
      this.dataCustomer = data;
      this.$refs.detailsCustomer.show(data);
    },
    handleProspectDetailDrawerClose() {
      this.prospectDrawer = false;
    }
  },
  computed: {
    ...mapGetters({
      list_currency: "currency/list_to_select",
      list_times: "times/list_to_select",
      list_deal_of_types: "deal_of_type/list_to_select",
      list_customers: "customers/list_to_select",
      loading_customers: "customers/isLoading",
      listProspects: "prospects/listProspects",
      listContact: "contact/listContact"
    }),
    amount() {
      let total = this.model.UnitPrice * this.model.Quantity;
      total = total ? total : 0;
      /*
      if (this.model.CurrencyID) {
        const cu = this.$store.getters["currency/getById"](
          this.model.CurrencyID
        );
        total = `${cu.Name} ${total}`;
      } */
      return total;
    },
    showProspect() {
      if (this.isProspect && this.fromAction) {
        return false;
      }

      if (this.isProspect) {
        return true;
      }

      return false;
    },
    showClient() {
      if (this.isClient && this.fromAction) {
        return false;
      }

      if (this.isClient) {
        return true;
      }
      return false;
    },
    controlerViewEdit() {
      if (!this.isView && this.isEdit) {
        return false;
      }

      return this.isView || this.isEdit;
    },
    buttonTitle() {
      if (this.isEdit) return "Guardar";
      return "Crear";
    }
  },
  watch: {
    amount(val) {
      this.model.Amount = val;
    },
    code(val) {
      if (this.isProspect) {
        this.getByProspectCode({
          contactCode: val
        });
      } else {
        this.getByCustomerCode({
          customerCode: val
        });
      }

      if (this.isView || this.isEdit) {
        this.remoteMethodProspect(val);
        this.ClickEditProspect();
        this.model.CompanyName = this.dataProspect.CompanyName;
      }
    },
    initModel(val) {
      this.model = val;
    }
  }
};
</script>
